import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../__partials/avatar';
import { marginClassNamePropType } from '../../__utils/spacingClassNamePropType';

const AvatarTeam = ({
  size,
  imageUrl,
  sport,
  primaryColor,
  secondaryColor,
  showOuterBorder,
  onMouseEnter,
  onMouseLeave,
  onClick,
  className,
  qaId,
}) => {
  return (
    <Avatar
      type="team"
      size={size}
      imageUrl={imageUrl}
      sport={sport}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      showOuterBorder={showOuterBorder}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      className={className}
      qaId={qaId}
    />
  );
};

AvatarTeam.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'profile']),
  imageUrl: PropTypes.string,
  sport: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  showOuterBorder: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  className: marginClassNamePropType,
  qaId: PropTypes.string,
};

AvatarTeam.defaultProps = {
  size: 'medium',
  className: '',
};

export default AvatarTeam;



// WEBPACK FOOTER //
// ./src/avatars/team/index.jsx